<link rel="ractive" href="./placeholder-skeleton.html" name="c-placeholder-skeleton">

<div class="c-gp-test-depiction">
	{{#if testType}}
		<div class="c-gp-test-depiction_test">
			{{#each contentPerTestType[testType]}}
				{{#if this.type === 'header'}}
					{{#if isLocationPresented}}
						<span class="c-gp-test-depiction_test_header">{{this.content}}</span>
					{{else}}
						<c-placeholder-skeleton type="header"></c-placeholder-skeleton>
					{{/if}}
				{{elseif this.type === 'subheader'}}
					{{#if isLocationPresented}}
						<span class="c-gp-test-depiction_test_subheader">{{this.content}}</span>
					{{else}}
						<c-placeholder-skeleton type="subheader"></c-placeholder-skeleton>
					{{/if}}
				{{elseif this.type === 'descr'}}
					{{#if isLocationPresented}}
						<p class="c-gp-test-depiction_test_descr">
							{{this.content}}
						</p>
					{{else}}
						<c-placeholder-skeleton type="descr"></c-placeholder-skeleton>
					{{/if}}
				{{elseif this.type === 'list'}}
					{{#if isLocationPresented}}
						<ul class="c-gp-test-depiction_test_list">
							{{#each this.content}}
								<li>{{this}}</li>
							{{/each}}
						</ul>
					{{else}}
						<c-placeholder-skeleton type="list" content="{{this.content}}"></c-placeholder-skeleton>
					{{/if}}
				{{/if}}
			{{/each}}
		</div>
	{{/if}}
</div>

<script>
	const CONTENT_TYPE_HEADER = 'header';
	const CONTENT_TYPE_SUBHEADER = 'subheader';
	const CONTENT_TYPE_DESCR = 'descr';
	const CONTENT_TYPE_LIST = 'list';

	component.exports = {
		computed: {
			contentPerTestType () {
				let locationData = this.get('locationData');
				let locationName = locationData ? locationData.name || locationData.from : 'World';

				return {
					ping: [
						{
							type: CONTENT_TYPE_HEADER,
							content: 'What is ping?',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Ping is a network testing and troubleshooting utility that helps identify problems when
you can't reach a server or experience slow loading times. It's also often used for simple
network performance monitoring, determining if a website is reachable from the local network, or resolving a hostname's IP address.`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Ping sends Internet Control Message Protocol (ICMP) packets from your location to a target
host (a hostname or IP address) to test connectivity. If everything goes well, the target
receives the request and sends back a response to confirm that it's reachable and working.
The response includes the round-trip time (RTT), which tells you how long it took for the
data to travel to the destination and back. This RTT can also indicate the latency, or delay, to the target.`,
						},
						{
							type: CONTENT_TYPE_HEADER,
							content: 'What are everyday use cases for ping?',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: 'Not sure how ping can help you? Here are some popular use cases:',
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Test network connectivity',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Ping is the go-to tool when you experience network issues. By sending data packets to a target
host and receiving a response, ping lets you quickly verify if the target is reachable and evaluate
the overall network connectivity.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Measure latency',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `You may have a network bottleneck or other performance issues if you spot unusually high RTTs in
your ping results. If you notice high latency but don't know where in the network the problem is,
pinging different hosts and comparing the RTTs helps find the problematic devices.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Test website reachability',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `When you can't load a website via your browser, ping the website's hostname to check if it's reachable
from your network. This lets you determine whether you're facing network-related issues or a problem with your browser.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Diagnose Internet connection problems',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Can't connect to the Internet? Ping your router's IP address to verify if your device can reach the
router, helping you find out if the issue lies within your local network or the Internet connection.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Monitor networks',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Create automated scripts that regularly ping one or more hosts and store the result data. Use this
data to identify hosts that frequently cause high response times, packet loss, or other problems so you can take action.`,
						},
						{
							type: CONTENT_TYPE_HEADER,
							content: `What are common use cases to run ping from ${locationName}?`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Sometimes you need to run network tests from locations that aren't accessible to you. That's where Globalping comes
to the rescue. It's a platform that relies on a globally distributed network of probes, allowing you to
perform measurements from any corner of the world.`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Running ping from ${locationName} and other places provides many insights and extends the
use cases we explored in the previous section:`,
						},
						{
							type: CONTENT_TYPE_LIST,
							content: [
								'Set up global network monitoring',
								'Test website availability from various regions',
								'Measure latency as experienced by users across the globe',
							],
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: 'Here are some additional use cases for geographically distributed ping:',
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Optimize content delivery',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Run ping from ${locationName} and other locations to test the latency to your website or API. Examine the ping's
RTTs - if they're unusually high, users likely experience delays and long loading times. To reduce latency,
consider using a CDN (Content Delivery Network) for efficient content distribution.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: `Troubleshoot from your users' perspective`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Imagine your website users in ${locationName} are reporting issues, but everything
seems fine from your end. With Globalping, you can run ping from ${locationName} as if you were doing it from your
location to troubleshoot the problem.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Monitor remote servers',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `If you manage servers around the globe, running ping from different locations can be of invaluable help for
monitoring performance and connectivity. This allows you to respond faster and more informed when issues in specific regions arise.`,
						},
					],
					traceroute: [
						{
							type: CONTENT_TYPE_HEADER,
							content: 'What is traceroute?',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Traceroute is a valuable network testing and troubleshooting utility that helps pinpoint potential issues along
the route between your device and the target host, such as when you're unable to reach a website or experience slow load times.`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Traceroute sends small data packets to a target hostname or IP address and lists each hop (usually a router) used to get there.
Each packet has a Time to Live (TTL) value, starting at 1, to limit its lifespan. As the data passes through each hop, the TTL value decreases by 1. Once it
reaches 0, the current router stops forwarding the packet and responds with a "TTL exceeded" message. Traceroute then takes note of the router's IP address,
increases the packet's initial TTL by 1, and resends the request.
Thanks to this back and forth, traceroute can compile a list of all the hops the data passes to the target, including the round-trip time (RTT) for each hop.`,
						},
						{
							type: CONTENT_TYPE_HEADER,
							content: 'What are common use cases for traceroute?',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Are you wondering what you can actually achieve by running traceroute? Here are some typical use cases:`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Measure performance',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `If you notice high latency to a target, run traceroute and look at each hop's round-trip time (RTT) to learn about the time it took for
the data packets to reach the destination and back. If you come across a hop with an unusually high RTT, it could indicate congestion or some other performance
issue at that point.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Analyze network paths',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Traceroute comes in handy when you need to know the path packets take through the network to reach a target host. Listing the IP addresses,
host names, and RTTs for each hop gives you a clearer picture of the network infrastructure. As a result, you may find potential bottlenecks or other problematic
segments, allowing you to take action quickly.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Troubleshoot network connectivity',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `When you're experiencing network connectivity issues, traceroute can help pinpoint the problem by collecting data about each hop between
your device and the target. Typically, the issue is with the last hop that sent a response or the one after that hop. Once you know where the problem is, you're a
big step closer to solving it.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Verify routing changes',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Running traceroute before and after making changes to your network infrastructure allows you to verify that the new routing's working as
expected. Compare traceroute results to ensure that data takes the correct path and identify any unexpected behavior you should fix.`,
						},
						{
							type: CONTENT_TYPE_HEADER,
							content: `What are everyday use cases to run traceroute from ${locationName}?`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `But how can you use traceroute when users report issues with your infrastructure in places that aren't accessible to you? This is where
Globalping can help you: The platform leverages a globally distributed network of probes, enabling you to send measurement requests from anywhere in the world.`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Running traceroute from ${locationName} and any other location provides insights on a global scale, adding to the use cases explored above:`,
						},
						{
							type: CONTENT_TYPE_LIST,
							content: [
								'Find network bottlenecks and measure latency globally',
								'Analyze and verify the paths data takes from different locations to a website or server',
								'Resolve network connectivity issues reported by users all over the world',
							],
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Let's explore some more use cases for running traceroute globally:`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Global network monitoring',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Running traceroute with Globalping regularly from different locations around the world gives you a comprehensive view of your network's
performance and connectivity. This allows you to resolve many network-related issues faster and ensure a consistently high user experience.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Compare service providers',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `When choosing the ideal CDN provider, DNS provider, or Cloud hosting company, running traceroute from ${locationName} and other locations
to the provider can help. Examine the number of hops, the round-trip times, and any potential performance spikes encountered along the path. That way, you can
determine which providers offer the best network connectivity and reliability for your desired locations.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: `Investigate user reports`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Are users in remote locations like ${locationName} reporting issues you can't reproduce? Use Globalping to run traceroute from an area near
these users to identify regional problems and determine the proper troubleshooting steps.`,
						},
					],
					dns: [
						{
							type: CONTENT_TYPE_HEADER,
							content: 'What is dig, and how to resolve DNS?',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Dig is a network testing and troubleshooting tool that allows you to retrieve DNS (Domain Name System) information, such as a
domain's IP address, DNS records, and name server information.`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `The dig command is quite flexible and lets you add options as needed. For example, you can query specific record types or define
the name server to query instead of your default resolver. When you run the dig command, you get a response divided into sections. The "authority section,"
for instance, lists the authoritative name servers that responded, and the "answer section" contains the response to your DNS query, such as the A record.`,
						},
						{
							type: CONTENT_TYPE_HEADER,
							content: 'What are typical scenarios for using dig?',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: 'Not sure what you can do with the dig command? Here are some ideas:',
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Perform DNS lookups',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Probably the most common use case for dig is to perform DNS lookups to provide you with information about the DNS configuration of a domain.
The data retrieved can include A records (IPv4 addresses), AAAA records (IPv6 addresses), MX records (mail server), NS records (name servers), and more.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Troubleshoot DNS issues',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Dig is also the go-to tool for troubleshooting DNS resolution problems. Using the command, you can verify if DNS records are configured
correctly and that DNS servers are responding as they should. Query DNS records and analyze the results to find misconfigurations, DNS propagation problems,
and other DNS issues.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Measure DNS performance',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `If you want to measure the performance and reliability of different DNS servers, dig can help you with that too. Examine DNS response times
and query statistics to identify potential bottlenecks or test the efficiency of DNS caching.`,
						},
						{
							type: CONTENT_TYPE_HEADER,
							content: `What are common use cases to run dig from ${locationName}?`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Sometimes you may experience DNS resolution issues or need to check DNS information from locations that aren't accessible to you.
That's where the Globalping platform comes into play. It consists of a network of globally distributed probes that allows you to perform DNS queries similar to dig
from any location.`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `If you run dig from different places around the world, you can perform DNS-related tasks on a global scale, extending the use cases listed
in the previous section:`,
						},
						{
							type: CONTENT_TYPE_LIST,
							content: [
								'Measure regional DNS performance',
								'Perform global DNS resolution',
								'Monitor and troubleshoot DNS issues globally',
							],
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `But there's more:`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: `Resolve DNS from ${locationName}`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Suppose your users in ${locationName} can't reach your website or email services. By running dig from ${locationName} with Globalping, you can
retrieve DNS information specific to that location. Examine the query results and look for misconfigurations that could affect your users' experience.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Test load balancers',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Load balancers help you distribute incoming network traffic, for example, if you run a busy website. You can run dig from ${locationName} and
other locations to test whether your load balancers work as intended. Use Globalping to query your domain's DNS record, which should return IP addresses representing
the used load balancers. Then, run the same dig command repeatedly and see if it returns different IP, showing the load balancer in action. `,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Debug CDN and multi-CDN setups',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Dig can also help you optimize global content delivery and troubleshoot CDN and multi-CDN setups. For example, use Globalping to perform
DNS queries by running dig from ${locationName} to identify the region's CDN nodes responsible for content delivery. This way, you can verify whether the content
is served to users from the closest nodes and compare DNS response times to find potential performance issues.`,
						},
					],
					mtr: [
						{
							type: CONTENT_TYPE_HEADER,
							content: 'What is mtr?',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `MTR (My Traceroute) is a network testing and troubleshooting utility that combines the functionality of the ping and traceroute commands.
It's designed to help identify issues along the path between your device and a specific destination, including connectivity problems, packet loss, and high latency.`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `When you run mtr, it sends small data packets to the target host. As the data travels through the network, mtr records information about
each hop (typically a router) passed on the way. For each hop, it notes the IP address and continuously updates the packet loss percentage and the average and
current round-trip time (RTT). While traceroute provides a snapshot of the network path at a specific time, mtr lets you observe what happens as the test progresses.`,
						},
						{
							type: CONTENT_TYPE_HEADER,
							content: 'What are typical scenarios for using mtr?',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: 'Here are three examples of what you can accomplish with mtr:',
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Analyze & troubleshoot network paths',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Running mtr gives you real-time data showing the network path between your device and a target host. By providing the IP address, hostname,
RTTs, and packet loss percentage for each hop, you can find bottlenecks and other problematic points and start targeted troubleshooting.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Plan & optimize network infrastructure',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Want to update the routing to improve your network infrastructure? Then run mtr to get data about your network paths before and after the
changes. This helps you determine if you're on the right track and take quick action if the results are not meeting your expectations.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Measure performance',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `MTR is also helpful in troubleshooting network issues that impact latency by helping you locate the root cause within the network.
Observe each hop's round-trip time (RTT) as the test progresses, and you can hopefully find the hops contributing to high latency and take measures, such as
moving servers or using a CDN.`,
						},
						{
							type: CONTENT_TYPE_HEADER,
							content: `What are typical use cases to run mtr from ${locationName}?`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `When troubleshooting network issues, running mtr from your location or a server you can access is often not enough. Instead, you may
want to perform measurements from various locations worldwide - fortunately, Globalping's global probe network allows you to do just that.`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: 'Running mtr globally expands the previously described usage scenarios:',
						},
						{
							type: CONTENT_TYPE_LIST,
							content: [
								'Analyze, plan, and optimize network paths from various regions',
								'Troubleshoot network problems wherever they occur',
								'Optimize content delivery for your international users',
							],
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `But there's more you can achieve when you run mtr from different places:`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Investigate regional user issues',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `If you receive reports from your users about connection problems, use Globalping to run mtr from ${locationName} or just about any
other location. This allows you to find the network segments that aren't working properly and then determine the needed steps to get to the bottom of the problem.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'SLA monitoring',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `If you have service level agreements with customers worldwide, monitoring your network infrastructure with mtr can help ensure that
performance and reliability meet agreed metrics. Of course, you can also use this in reverse to ensure that your SLAs with service providers are met in
various locations.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Compare CDN performance and quality',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Want to find the best content delivery networks (CDN) in ${locationName} or other locations? Use Globalping to run mtr from different sites
within ${locationName} to compare the performance and reliability of the providers' network infrastructures. Then, compare the results with those from other regions
to find the CDN provider that best meets your needs in your most important locations.`,
						},
					],
					http: [
						{
							type: CONTENT_TYPE_HEADER,
							content: 'What is curl?',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: 'Curl is a tool that lets you make HTTP requests and retrieve content or get information from URLs directly from the command line.',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `You often use curl to make HEAD or GET requests to URLs. For instance, when you make a HEAD request, you get information about the host
and web server associated with the URL. For a GET request, the server responds with the contents of the URL, such as a web page or data from an API GET endpoint.
Each response from the server contains a status code like 404 for "not found" or 200 for successful requests. You can use these codes to determine if the requested
resource is accessible and if there are any server problems.`,
						},
						{
							type: CONTENT_TYPE_HEADER,
							content: 'What are some everyday use cases for curl to send HTTP requests?',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Not sure what you can achieve by sending HTTP GET or HEAD requests?
Here are some ideas:`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Verify service availability',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Adding HTTP GET and HEAD requests to your monitoring setup is an effective and simple way to keep an eye on the availability and
response times of your website or servers. Set up alerts to be able to quickly address issues and ensure that everything is back up and running in no time.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Check HTTP headers',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `When making an HTTP HEAD request to a website or API using curl, you can fetch the header information without the URL's content.
This allows you to explore and verify cache directives (e.g., ETag or Cache-Control), server information (e.g., software and version), content type, encoding,
and security measures (e.g., Content-Security-Policy or Strict-Transport-Security).`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Debugging and troubleshooting',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Curl can also be super helpful in numerous troubleshooting scenarios. For example, you can send requests to your API endpoints using
different parameter values and request headers to test and verify the responses. Or you can use it to evaluate the performance of your service by measuring
the time it takes a GET or HEAD request to your service to send you a response.`,
						},
						{
							type: CONTENT_TYPE_HEADER,
							content: `What can I achieve by making HTTP requests from ${locationName}?`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `If you run a website or an API, your users often report problems with your service from different locations that you'd like to investigate
but can't because the location is out of your reach. That's where our Globalping network testing platform comes to the rescue. It consists of a global probe network
that allows you to perform various network commands from anywhere.`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: 'The ability to make HTTP requests using curl from anywhere in the world makes the above scenarios even more interesting:',
						},
						{
							type: CONTENT_TYPE_LIST,
							content: [
								'Debug and troubleshoot regional issues with your website or server',
								'Verify the availability and performance of your website or API from all over the world',
							],
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Let's explore some more use cases:`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: `Test services from your user's perspective`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Imagine your users in ${locationName} are reporting unusual behavior from one of your API GET endpoints that you can't reproduce from your
location. To get to the bottom of the problem, you can start troubleshooting by running curl from ${locationName} using Globalping. By making a GET request,
you can retrieve the API response as seen by your users, helping you learn more about the problem and determine your next troubleshooting steps.`,
						},
						{
							type: CONTENT_TYPE_SUBHEADER,
							content: 'Investigate censorship & content modification',
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Another interesting way to use Globalping is to run curl from ${locationName} or any other location to learn about censorship or content
modification in that area. For example, you can make a HEAD request to check if a URL is accessible or perform a GET request to compare the content of a URL
with your local version, ensuring that it hasn't been changed.`,
						},
						{
							type: CONTENT_TYPE_DESCR,
							content: `Globalping also provides performance metrics for each HTTP request, including the response time, content download time, time to first
byte, DNS resolution time, and the time taken to establish the TLS and TCP connection with the server. This allows you to run performance benchmarks and
comparisons from ${locationName}. Measure and understand the local and global latency of your service or the service providers you use, such as CDN, DNS, and
Edge computing companies.`,
						},
					],
				};
			},
			testType () {
				let selectedTestType = this.get('selectedTestType');

				return selectedTestType ? selectedTestType.toLowerCase() : 'ping';
			},
			isLocationPresented () {
				let locationData = this.get('locationData');

				return locationData !== null && typeof locationData === 'object';
			},
		},
	};
</script>
